import React, { useState, useEffect } from 'react';
import LineChartComponent from '@/components/charts/Line';

interface FundCombinationProps {
  selectedMetrics: {
    fundCombination?: boolean;
    [key: string]: boolean | undefined;
  };
}

const FundCombination: React.FC<FundCombinationProps> = ({ selectedMetrics }) => {
  const [currentSelectedMetrics, setCurrentSelectedMetrics] = useState<{
    fundCombination?: boolean;
    [key: string]: boolean | undefined;
  }>({});

  // 图表数据状态
  const [chartData, setChartData] = useState({
    annualReturn: [
      { value: 0 },
      { value: 2.1 },
      { value: 4.3 },
      { value: 6.8 },
      { value: 5.2 },
      { value: 8.2 }
    ],
    maxDrawdown: [
      { value: 0 },
      { value: -2.1 },
      { value: -5.3 },
      { value: -8.7 },
      { value: -12.6 },
      { value: -10.2 }
    ]
  });

  useEffect(() => {
    setCurrentSelectedMetrics(selectedMetrics);
  }, [selectedMetrics]);

  // 模拟数据变化
  useEffect(() => {
    const interval = setInterval(() => {
      setChartData(prev => ({
        annualReturn: prev.annualReturn.map(item => ({
          value: Math.max(0, item.value + (Math.random() - 0.5) * 2)
        })),
        maxDrawdown: prev.maxDrawdown.map(item => ({
          value: Math.min(0, item.value + (Math.random() - 0.5) * 1.5)
        }))
      }));
    }, 2000); // 每2秒更新一次数据

    return () => clearInterval(interval);
  }, []);

  const handleCheckboxChange = (checked: boolean) => {
    setCurrentSelectedMetrics(prev => ({
      ...prev,
      fundCombination: checked
    }));
  };

  return (
    <div className="border border-[#F0F0F0] rounded-lg p-3 my-4">
      {/* 标题和复选框 */}
      <div className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          checked={currentSelectedMetrics.fundCombination || false}
          onChange={e => handleCheckboxChange(e.target.checked)}
          className="w-4 h-4"
        />
        <span className="text-base font-semibold text-[#1F1F1F]">推荐基金产品组合</span>
      </div>

      {/* 基金组合指标卡片 */}
      <div className="grid grid-cols-2 gap-3">
        {/* 近一年收益 */}
        <div className="bg-white border border-[#F0F0F0] rounded-md p-2 flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <span className="text-xs text-[#1F1F1F]">近一年收益</span>
            <span className="text-base font-semibold text-[#F5222D]">+8.2%</span>
          </div>
          <LineChartComponent data={chartData.annualReturn} stroke="#5959EB" height="42px" />
        </div>

        {/* 近一年最大回撤 */}
        <div className="bg-white border border-[#F0F0F0] rounded-md p-2 flex flex-col gap-3">
          <div className="flex justify-between items-center">
            <span className="text-xs text-[#1F1F1F]">近一年最大回撤</span>
            <span className="text-base font-semibold text-[#F5222D]">-12.6%</span>
          </div>
          <LineChartComponent data={chartData.maxDrawdown} stroke="#1677FF" height="34px" />
        </div>
      </div>
    </div>
  );
};

export default FundCombination;
